import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
    width: 200px;
    height: 180px;
    max-height: 200px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;

    h1 { 
        font-size: 1rem;
        color: #fafafa;
    }

    img { 
        min-width: 120px;
        max-width: 120px;
        height: auto;
        object-fit: contain;
    }
`;

// eslint-disable-next-line react/prop-types
export default function TecnologiesCard({ title, image }) {
  return (
    <Card>
      <img src={image} alt={title} />
      <h1>{title}</h1>
    </Card>
  );
}
